/* C4 — artwork plans on Apippa (legacy) product pages, plus the cart-drawer refresh.
 *
 * Loaded by the custom-liquid section c4_plans_assets in templates/product.button-upload-noquant.json
 * and product.c4-legacy.json, and by snippets/c4-cart-signin.liquid (cart drawer / cart page).
 * Self-guarding, so a drawer re-render cannot run it twice.
 *
 * 1. Price: when a paid plan is pending on a legacy form, the price block, the Add to cart button,
 *    the sticky bar and Apippa's own price box show print + plan. The figures written by
 *    c4-legacy.js / Apippa are left alone; the total is drawn over them from a data attribute, so
 *    the scripts never fight over text.
 * 2. Plan line: after Apippa's print job is confirmed added, the plan variant is added as its own
 *    line. Never before, so a failed job cannot leave an orphaned paid plan.
 * 3. Clean lines: calculator properties whose field is hidden (options the customer did not pick)
 *    are dropped from the job before it is added.
 * 4. Drawer: re-rendered after the add, and again while a freshly created Apippa variant still
 *    shows $0.00, so the drawer matches the cart.
 * 5. Plans overlay: chosen state for every option (Free and "Not sure" included), restored when
 *    the overlay reopens; paid plan cleared when the customer switches to another artwork route.
 * 6. Nudges: after choosing "We design it", the design packages link is highlighted until a plan
 *    is chosen; after choosing "Design it online", "Browse free templates" bobs downwards towards the
 *    template carousel until the customer uses it.
 * 7. Overlay copy follows the Artwork page (/pages/artwork): names, prices, one-liners, features and
 *    badge are read from that page, so editing the Artwork page updates the overlay too.
 * 8. The Tawk chat bubble is hidden while the plans panel is open, so it cannot cover Save.
 */
(function () {
  if (window.__c4LegacyPlans) return;
  window.__c4LegacyPlans = true;

  var FORM_ID = 'c4-product-form';
  var DRAWER_SECTION = 'cart-drawer-section';
  var PRICE_SEL = '[data-c4-price], [data-c4-cta-price], [data-c4-sticky-v]';
  var BTN_SEL = '[data-c4-plan-choose], [data-c4-plan-pick]';

  function form() { return document.getElementById(FORM_ID); }
  function isLegacy() { var f = form(); return !!(f && f.hasAttribute('data-c4-legacy')); }

  function pendingPlan() {
    var f = form(), el = f && f.querySelector('[data-c4-plan-pending]');
    if (!el || !el.value) return null;
    try {
      var p = JSON.parse(el.value);
      return p && p.id && p.cents > 0 ? p : null;
    } catch (e) { return null; }
  }
  function clearPendingPlan() {
    var f = form(), el = f && f.querySelector('[data-c4-plan-pending]');
    if (el) el.value = '';
  }
  function planField() {
    var f = form();
    return f && f.querySelector('input[name="properties[Artwork Plan]"]');
  }
  function toCents(text) {
    var s = String(text || '').replace(/,/g, '');
    var m = s.match(/(\d+(?:\.\d{1,2})?)/);
    return m ? Math.round(parseFloat(m[1]) * 100) : null;
  }
  function money(c) {
    return '$' + (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function esc(name) {
    return window.CSS && CSS.escape ? CSS.escape(name) : String(name).replace(/(["\\\]\[])/g, '\\$1');
  }
  function productTitle() {
    var h = document.querySelector('main h1') || document.querySelector('h1');
    return (h && h.textContent.trim()) || document.title;
  }
  function designRouteInput() {
    var f = form();
    if (!f) return null;
    var open = f.querySelector('[data-c4-plans-open]');
    var label = open && open.closest('label');
    return label ? label.querySelector('input[type="radio"]') : null;
  }
  function designRouteChosen() {
    var r = designRouteInput();
    return !!(r && r.checked);
  }

  /* ---------- 1. Price display ---------- */

  function paint() {
    var plan = isLegacy() ? pendingPlan() : null;

    document.querySelectorAll(PRICE_SEL).forEach(function (el) {
      var text = el.textContent || '';
      var base = toCents(text);
      if (plan && base !== null && !/from/i.test(text)) {
        if (!el.style.getPropertyValue('--c4-plan-fs')) {
          el.style.setProperty('--c4-plan-fs', getComputedStyle(el).fontSize);
        }
        var want = money(base + plan.cents);
        if (el.getAttribute('data-c4-plan-total') !== want) el.setAttribute('data-c4-plan-total', want);
      } else if (el.hasAttribute('data-c4-plan-total')) {
        el.removeAttribute('data-c4-plan-total');
      }
    });

    /* Apippa's own "PRICE incl. GST $ 45" box: its "$" sits outside the number, so the total is
       written the way Apippa writes it (whole dollars unless it shows cents). */
    var ticker = document.getElementById('priceTicker');
    if (ticker) {
      var tText = ticker.textContent || '';
      var tBase = toCents(tText);
      if (plan && tBase !== null) {
        if (!ticker.style.getPropertyValue('--c4-plan-fs')) {
          ticker.style.setProperty('--c4-plan-fs', getComputedStyle(ticker).fontSize);
        }
        var tSum = (tBase + plan.cents) / 100;
        var tWant = (/\./.test(tText) ? tSum.toFixed(2) : String(Math.round(tSum))).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        if (ticker.getAttribute('data-c4-plan-total') !== tWant) ticker.setAttribute('data-c4-plan-total', tWant);
      } else if (ticker.hasAttribute('data-c4-plan-total')) {
        ticker.removeAttribute('data-c4-plan-total');
      }
    }

    var label = plan ? 'incl. ' + money(plan.cents) + ' ' + plan.name + ' artwork plan' : '';

    /* The plan line takes the place of the "as low as" line (same slot, drawn on top), so the
       price box never changes height when a plan is chosen or cleared. */
    var cell = document.querySelector('.c4-price [data-c4-price]');
    var box = cell && cell.closest('.c4-price');
    var note = document.querySelector('.c4-price [data-c4-plan-note]');
    var low = box && box.querySelector('[data-c4-price-low]');
    if (plan && cell) {
      if (!note) {
        note = document.createElement('div');
        note.className = 'c4-price__plan';
        note.setAttribute('data-c4-plan-note', '');
        (low || cell).insertAdjacentElement('afterend', note);
      }
      if (note.textContent !== label) note.textContent = label;
      if (low) {
        var top = low.offsetTop + 'px';
        if (note.style.top !== top) note.style.top = top;
        if (!note.classList.contains('c4-price__plan--over')) note.classList.add('c4-price__plan--over');
      }
      if (note.hidden) note.hidden = false;
      if (box && !box.classList.contains('c4-price--plan')) box.classList.add('c4-price--plan');
    } else {
      if (note && !note.hidden) note.hidden = true;
      if (box && box.classList.contains('c4-price--plan')) box.classList.remove('c4-price--plan');
    }

    var fig = document.querySelector('[data-c4-cta] .c4-cta__fig');
    var row = fig && fig.querySelector('[data-c4-cta-plan]');
    if (plan && fig) {
      if (!row) {
        row = document.createElement('span');
        row.className = 'c4-cta__row c4-cta__plan';
        row.setAttribute('data-c4-cta-plan', '');
        fig.appendChild(row);
      }
      var short = 'incl. ' + plan.name + ' plan';
      if (row.textContent !== short) row.textContent = short;
      if (row.hidden) row.hidden = false;
    } else if (row && !row.hidden) {
      row.hidden = true;
    }

    nudge();
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; paint(); });
  }

  /* ---------- 6. Nudge towards the plans overlay ---------- */

  /* "Design it online" is ticked by default, so its nudge starts only when the customer picks it
     themselves, and stops once they use the templates (browse, pick a tile) or a design is saved. */
  var templatesTouched = false;
  var templatesUsed = false;

  function nudge() {
    var f = form();
    if (!f) return;
    var link = f.querySelector('[data-c4-plans-open]');
    if (link) {
      var field = planField();
      var want = designRouteChosen() && !(field && field.value);
      if (link.classList.contains('c4-plans-nudge') !== want) link.classList.toggle('c4-plans-nudge', want);
    }
    var browse = f.querySelector('[data-c4-design-browse]');
    if (browse) {
      var lab = browse.closest('label');
      var radio = lab && lab.querySelector('input[type="radio"]');
      var wantB = templatesTouched && !templatesUsed && !!(radio && radio.checked) && !/saved|ready/i.test(browse.textContent);
      if (browse.classList.contains('c4-templates-nudge') !== wantB) browse.classList.toggle('c4-templates-nudge', wantB);
    }
  }

  /* "Browse free templates" goes to the template carousel, not the editor (Cathy, 17 Sep 2026:
     customers should pick a design from the carousel first). The card snippet's own handler opens
     the editor, so this listens on WINDOW in the capture phase, which runs before any document or
     card listener, and stops the click there. If this product/size has no carousel tiles, the click
     is left alone and the editor opens as before, so the link never goes dead.
     The carousel lights up one step earlier, as soon as "Design it online" is tapped, and is
     scrolled into view then if it sits below the fold (clear of the sticky Add to cart bar). */
  function carouselWithTiles() {
    var c = document.querySelector('[data-c4-pp-carousel]');
    if (!c) return null;
    var real = c.querySelectorAll('.c4-ppc__item[data-design-id]:not(.is-clone)');
    return real.length ? c : null;
  }

  function bringCarouselIntoView(carousel) {
    var r = carousel.getBoundingClientRect();
    var sticky = document.querySelector('.c4-sticky.is-on');
    var bottomLimit = window.innerHeight - (sticky ? sticky.getBoundingClientRect().height : 0) - 16;
    var topLimit = 90;
    var delta = 0;
    if (r.top < topLimit) delta = r.top - topLimit;
    else if (r.bottom > bottomLimit) delta = Math.min(r.bottom - bottomLimit, r.top - topLimit);
    if (Math.abs(delta) < 4) return;
    try { window.scrollBy({ top: delta, behavior: 'smooth' }); }
    catch (err) { window.scrollBy(0, delta); }
  }

  function flashCarousel(carousel) {
    carousel.classList.remove('c4-ppc--flash');
    void carousel.offsetWidth;
    carousel.classList.add('c4-ppc--flash');
    clearTimeout(carousel.__c4FlashT);
    carousel.__c4FlashT = setTimeout(function () { carousel.classList.remove('c4-ppc--flash'); }, 1900);
  }

  function showCarousel(delay) {
    setTimeout(function () {
      var carousel = carouselWithTiles();
      if (!carousel) return;
      carousel.hidden = false;
      bringCarouselIntoView(carousel);
      flashCarousel(carousel);
    }, delay);
  }

  window.addEventListener('click', function (e) {
    var browse = e.target.closest && e.target.closest('[data-c4-design-browse]');
    if (!browse) return;
    if (!carouselWithTiles()) return;
    e.preventDefault();
    e.stopImmediatePropagation();

    var lab = browse.closest('label') || browse.closest('[data-c4-design-card]');
    var radio = lab && lab.querySelector('input[type="radio"]');
    if (radio && !radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
    templatesUsed = true;
    schedule();
    showCarousel(60);
  }, true);

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('[data-c4-design-browse]') || e.target.closest('[data-design-id]')) {
      templatesUsed = true;
      schedule();
      return;
    }
    /* Tapping the Design it online card counts as choosing it, even though it starts ticked. */
    var card = e.target.closest('label');
    if (card && card.querySelector('[data-c4-design-browse]')) {
      templatesTouched = true;
      templatesUsed = false;
      setTimeout(schedule, 0);
      showCarousel(150);
    }
  }, true);

  /* ---------- 5. Plans overlay: chosen state ---------- */

  function planButtons() { return document.querySelectorAll(BTN_SEL); }

  function rememberLabels() {
    planButtons().forEach(function (b) {
      if (b.hasAttribute('data-c4-label')) return;
      var t = b.textContent.trim();
      if (/^(✓\s*)?Chosen$/.test(t)) t = b.hasAttribute('data-c4-plan-choose') ? 'Choose ' + (b.getAttribute('data-c4-plan-name') || '') : t;
      b.setAttribute('data-c4-label', t);
    });
  }

  function markChosen(name) {
    rememberLabels();
    planButtons().forEach(function (b) {
      var on = !!name && b.getAttribute('data-c4-plan-name') === name;
      var card = b.parentElement;
      if (card) card.classList.toggle('c4-plan-card--on', on);
      b.classList.toggle('c4-plan-btn--on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var want = on ? '✓ Chosen' : b.getAttribute('data-c4-label');
      if (b.textContent !== want) b.textContent = want;
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest(BTN_SEL);
    if (btn) {
      rememberLabels(); /* capture phase: before the section's handler renames buttons */
      var name = btn.getAttribute('data-c4-plan-name');
      /* Let the section's own handler record the plan first, then show the state. */
      setTimeout(function () { markChosen(name); schedule(); }, 0);
      return;
    }
    var open = e.target.closest && e.target.closest('[data-c4-plans-open]');
    if (open) {
      setTimeout(function () {
        var field = planField();
        markChosen(field && field.value);
      }, 0);
    }
  }, true);

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.name !== 'properties[Artwork Supplied]') { schedule(); return; }
    var designLab = t.closest && t.closest('label');
    if (t.checked && designLab && designLab.querySelector('[data-c4-design-browse]')) {
      templatesTouched = true;
      templatesUsed = false;
    }
    var r = designRouteInput();
    if (r && t !== r && t.checked) {
      /* Plans belong to "We design it". Moving to another route drops a paid plan. */
      if (pendingPlan()) {
        clearPendingPlan();
        var field = planField();
        if (field) field.value = '';
        markChosen(null);
      }
    }
    schedule();
  }, true);

  document.addEventListener('c4:plan-chosen', schedule);

  /* ---------- 3. Drop hidden calculator properties ---------- */

  /* How a calculator field is hidden:
     'condition' — Apippa's conditional display (inline display:none): an option not picked.
     'css'       — hidden by a stylesheet: Apippa's deliberate hidden helpers (m2, Input2, …) or
                   the theme hiding Apippa's own artwork tiles.
     null        — on screen. */
  function hiddenBy(el) {
    for (var n = el.parentElement; n && n !== document.body; n = n.parentElement) {
      if (n.hidden || (n.style && n.style.display === 'none')) return 'condition';
      if (getComputedStyle(n).display === 'none') return 'css';
      if (n.id === 'calculator') return null;
    }
    return null;
  }
  /* Apippa's artwork questions: the theme's own artwork cards replace them, so a hidden copy is
     never meaningful on the order, however it was hidden. */
  var ARTWORK_FAMILY = /^properties\[(Artwork Supplied|Do you need design assistance\?|Do you require artwork\?|Notes)( \(.*\))?\]$/;

  function stripHidden(fd) {
    var calc = document.getElementById('calculator');
    if (!calc) return;
    var f = form();
    var keys = [];
    fd.forEach(function (v, k) {
      if (/^properties\[[^_]/.test(k) && keys.indexOf(k) === -1) keys.push(k);
    });
    keys.forEach(function (k) {
      var sel = '[name="' + esc(k) + '"]';
      var inCalc = calc.querySelectorAll(sel);
      if (!inCalc.length) return;
      if (f) {
        var themeOwned = Array.prototype.some.call(f.querySelectorAll(sel), function (el) {
          return !calc.contains(el);
        });
        if (themeOwned) return;
      }
      var how = Array.prototype.map.call(inCalc, hiddenBy);
      if (how.indexOf(null) !== -1) return; /* on screen somewhere: keep */
      var allConditional = how.every(function (h) { return h === 'condition'; });
      if (allConditional || ARTWORK_FAMILY.test(k)) fd.delete(k);
    });
  }

  /* ---------- 2. Add the plan line after the job ---------- */

  function param(name) {
    try { return new URLSearchParams(location.search).get(name) || ''; } catch (e) { return ''; }
  }

  function addPlanLine(plan, jobItem, fd) {
    var editing = param('pp_line');
    var check = editing
      ? fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            return (cart.items || []).some(function (it) {
              return it.variant_id === plan.id && it.properties && it.properties._c4_plan_for === editing;
            });
          })
          .catch(function () { return false; })
      : Promise.resolve(false);

    return check.then(function (alreadyCharged) {
      if (alreadyCharged) return null;
      var props = { For: productTitle(), _c4_plan_for: jobItem.key };
      var brief = fd.get('properties[Design brief]');
      if (brief) props.Brief = String(brief).slice(0, 500);
      var link = fd.get('properties[Reference link]');
      if (link) props['Reference link'] = String(link);
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: plan.id, quantity: 1, properties: props }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('plan add failed');
        clearPendingPlan();
        schedule();
        return r.json();
      });
    });
  }

  function planFailedNotice(plan) {
    var btn = document.querySelector('[data-c4-cta]');
    if (!btn) return;
    var n = document.createElement('p');
    n.className = 'c4-plan-fail';
    n.textContent = 'Your print job was added, but the ' + plan.name + ' artwork plan could not be. Please add it again or tell us in the order notes.';
    btn.insertAdjacentElement('afterend', n);
    setTimeout(function () { n.remove(); }, 12000);
  }

  var nativeFetch = window.fetch;
  if (nativeFetch) {
    window.fetch = function (input, init) {
      var url = '';
      try { url = String((input && input.url) || input || ''); } catch (e) {}
      var body = init && init.body;
      var isJob = false;
      try {
        isJob = /\/cart\/add\.js(?:\?|$)/.test(url) &&
          String((init && init.method) || '').toUpperCase() === 'POST' &&
          typeof FormData !== 'undefined' && body instanceof FormData &&
          body.has('properties[_cpc_custom_cart_item]') && isLegacy();
      } catch (e) { isJob = false; }
      if (!isJob) return nativeFetch.apply(this, arguments);

      try { stripHidden(body); } catch (e) {}
      var plan = pendingPlan();
      var request = nativeFetch.apply(this, arguments);
      if (!plan) return request;

      return request.then(function (res) {
        if (!res.ok) return res;
        return res.clone().json().then(function (data) {
          var item = data && (data.items ? data.items[0] : data);
          if (!item || !item.key || data.status) return res;
          return addPlanLine(plan, item, body).then(
            function () { return res; },
            function () { planFailedNotice(plan); return res; }
          );
        }).catch(function () { return res; });
      });
    };
  }

  /* ---------- 4. Drawer refresh after an add ---------- */

  var rendererLoad = null;
  function renderer() {
    if (!rendererLoad) {
      var dyn;
      try { dyn = new Function('u', 'return import(u)'); } catch (e) { dyn = null; }
      rendererLoad = (dyn ? dyn('@theme/section-renderer') : Promise.reject(new Error('no import')))
        .then(function (m) { return m && m.sectionRenderer; })
        .catch(function () { rendererLoad = null; return null; });
    }
    return rendererLoad;
  }
  function drawerPresent() { return !!document.getElementById('shopify-section-' + DRAWER_SECTION) || !!document.querySelector('[data-section-id="' + DRAWER_SECTION + '"]'); }
  function refreshDrawer() {
    if (!drawerPresent()) return Promise.resolve();
    return renderer().then(function (r) {
      if (!r) return;
      return r.renderSection(DRAWER_SECTION, { cache: false, mode: 'hydration' });
    }).catch(function () {});
  }
  function unpricedLines() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return (cart.items || []).some(function (it) { return it.final_line_price === 0 && it.properties && '_cpc_custom_cart_item' in it.properties; });
      })
      .catch(function () { return false; });
  }

  var refreshRun = 0;
  document.addEventListener('c4:cart-added', function () {
    var run = ++refreshRun;
    var tries = 0;
    function step(delay) {
      setTimeout(function () {
        if (run !== refreshRun) return;
        refreshDrawer().then(function () {
          tries++;
          if (tries >= 6) return;
          return unpricedLines().then(function (zero) {
            if (zero) step(1200);
            else if (tries === 1) step(2000); /* one safety pass */
          });
        });
      }, delay);
    }
    step(900);
  });

  /* ---------- 7. Plans overlay follows the Artwork page ----------
     The Artwork page (/pages/artwork, sections/c4-artwork.liquid) is the single source of truth for
     plan names, prices, one-line descriptions, feature lists and the badge. The overlay's own copy
     (snippets/c4-design-plans.liquid) is only the fallback shown until the page has been read.
     Matching is by tier — the first word of the plan name (Free / Basic / Moderate / Heavy) — so
     the variant ids, prices charged and the "Artwork Plan" value on orders never change here.
     The first read in a browser fetches the whole page and remembers its section id; later reads
     use the lightweight section rendering API. Cached for 30 minutes. */

  var ART_URL = '/pages/artwork';
  /* Keys carry the theme id: a draft preview and the live theme share this browser's storage. */
  var THEME_ID = (window.Shopify && Shopify.theme && Shopify.theme.id) || 'theme';
  var ART_CACHE = 'c4-artwork-plans-v1-' + THEME_ID;
  var ART_SECTION = 'c4-artwork-plans-section-' + THEME_ID;
  var ART_TTL = 30 * 60 * 1000;
  var artworkPlans = null;

  function clean(el) { return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; }
  function tier(name) {
    var m = String(name || '').trim().toLowerCase().match(/^[a-z]+/);
    return m && /^(free|basic|moderate|heavy)$/.test(m[0]) ? m[0] : '';
  }
  function store(key, value) { try { localStorage.setItem(key, value); } catch (e) {} }
  function recall(key) { try { return localStorage.getItem(key); } catch (e) { return null; } }

  function parseArtwork(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var band = doc.getElementById('design-plans');
    if (!band) return null;
    var wrap = band.closest('[id^="shopify-section-"]');
    if (wrap) store(ART_SECTION, wrap.id.replace(/^shopify-section-/, ''));
    var plans = Array.prototype.map.call(band.querySelectorAll('.c4a__plan'), function (p) {
      var priceEl = p.querySelector('.c4a__price');
      var price = priceEl && priceEl.firstChild ? String(priceEl.firstChild.textContent).trim() : clean(priceEl);
      return {
        name: clean(p.querySelector('h3')),
        badge: clean(p.querySelector('.c4a__badge')),
        price: price,
        what: clean(p.querySelector('.c4a__what')),
        feats: Array.prototype.map.call(p.querySelectorAll('.c4a__feats li'), clean).filter(Boolean)
      };
    }).filter(function (p) { return tier(p.name); });
    if (!plans.length) return null;
    return { title: clean(band.querySelector('h2')), sub: clean(band.querySelector('.c4a__sub')), plans: plans };
  }

  function fetchArtwork() {
    var sid = recall(ART_SECTION);
    var viaSection = sid
      ? fetch(ART_URL + '?sections=' + encodeURIComponent(sid), { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (j) { return j && j[sid] ? parseArtwork(j[sid]) : null; })
          .catch(function () { return null; })
      : Promise.resolve(null);
    return viaSection.then(function (d) {
      if (d) return d;
      return fetch(ART_URL, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) { return html ? parseArtwork(html) : null; })
        .catch(function () { return null; });
    });
  }

  function loadArtworkPlans() {
    var cached = null;
    try { cached = JSON.parse(recall(ART_CACHE) || 'null'); } catch (e) { cached = null; }
    if (cached && cached.d && Date.now() - cached.t < ART_TTL) {
      artworkPlans = cached.d;
      applyArtworkPlans();
      return;
    }
    fetchArtwork().then(function (d) {
      if (!d) return;
      artworkPlans = d;
      store(ART_CACHE, JSON.stringify({ t: Date.now(), d: d }));
      applyArtworkPlans();
    });
  }

  function setText(el, text) { if (el && text && el.textContent !== text) el.textContent = text; }

  function applyArtworkPlans() {
    var d = artworkPlans;
    var dialog = document.querySelector('[aria-labelledby="c4-plans-title"]');
    if (!d || !dialog) return;
    var heading = document.getElementById('c4-plans-title');
    setText(heading, d.title);
    if (heading && heading.nextElementSibling && heading.nextElementSibling.tagName === 'P') setText(heading.nextElementSibling, d.sub);

    var buttons = Array.prototype.slice.call(dialog.querySelectorAll(BTN_SEL));
    var badgeModel = null;
    buttons.forEach(function (b) {
      var head = b.parentElement && b.parentElement.firstElementChild;
      if (!badgeModel && head && head.children.length > 1) badgeModel = head;
    });

    d.plans.forEach(function (p) {
      var key = tier(p.name);
      var btn = buttons.filter(function (b) { return tier(b.getAttribute('data-c4-plan-name')) === key; })[0];
      if (!btn) return;
      var card = btn.parentElement;
      var kids = card.children;
      if (kids.length < 4) return;

      /* name and badge */
      var head = kids[0];
      if (p.badge && head.children.length < 2 && badgeModel) {
        var fresh = badgeModel.cloneNode(true);
        card.replaceChild(fresh, head);
        head = fresh;
      }
      if (head.children.length > 1) {
        setText(head.children[0], p.name);
        var badge = head.children[1];
        if (p.badge) { setText(badge, p.badge); badge.hidden = false; badge.style.display = ''; }
        else { badge.hidden = true; badge.style.display = 'none'; }
      } else {
        setText(head, p.name);
      }

      /* price and one-liner */
      setText(kids[1], p.price);
      setText(kids[2], p.what);

      /* features */
      var ul = card.querySelector('ul');
      if (ul && p.feats.length) {
        var now = Array.prototype.map.call(ul.children, clean);
        if (now.join('|') !== p.feats.join('|')) {
          ul.textContent = '';
          p.feats.forEach(function (f) {
            var li = document.createElement('li');
            li.textContent = f;
            ul.appendChild(li);
          });
        }
      }

      /* button label follows the name; the recorded plan name does not */
      var word = p.name.split(/\s+/)[0];
      var label = 'Choose ' + word;
      btn.setAttribute('data-c4-label', label);
      if (!/Chosen/.test(btn.textContent)) setText(btn, label);
    });
  }

  /* ---------- wiring ---------- */

  function start() {
    if (!form()) return;
    rememberLabels();
    paint();
    var plansDialog = document.querySelector('[aria-labelledby="c4-plans-title"]');
    if (plansDialog) {
      /* The chat bubble (Tawk) sits bottom-right, over the panel's Save button. Hide it while the
         plans panel is open; bring it back when the panel closes. */
      var plansRoot = plansDialog.closest('[data-c4-plans]') || plansDialog.parentElement;
      var chat = function (show) {
        try {
          var T = window.Tawk_API;
          if (T && show && typeof T.showWidget === 'function') T.showWidget();
          if (T && !show && typeof T.hideWidget === 'function') T.hideWidget();
        } catch (e) {}
      };
      if (plansRoot) {
        new MutationObserver(function () { chat(plansRoot.hidden); })
          .observe(plansRoot, { attributes: true, attributeFilter: ['hidden'] });
      }
      setTimeout(loadArtworkPlans, 1500);
      document.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('[data-c4-plans-open]')) applyArtworkPlans();
      }, true);
    }
    try {
      new MutationObserver(schedule).observe(form().closest('main') || document.body, {
        subtree: true, childList: true, characterData: true
      });
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();